import { Link } from "react-router-dom";
import { specialsList } from "@/mocks/specials";

export default function SpecialSection() {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-layout-grid-line text-xl text-primary-600" />
              <span className="text-sm font-medium text-primary-700">专题策划</span>
            </div>
            <h2 className="mt-2 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
              主题专题推荐
            </h2>
          </div>
          <Link
            to="/special"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            全部专题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {specialsList.slice(0, 3).map((s) => (
            <Link
              key={s.id}
              to="/special"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={s.cover}
                  alt={`${s.title} - 91动漫专题`}
                  title={`${s.title} - 91动漫`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 to-transparent" />
                <h3 className="absolute bottom-3 left-4 right-4 font-heading text-lg font-bold text-white">
                  {s.title}
                </h3>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <p className="line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{s.intro}</p>
                <span className="mt-3 flex items-center gap-1 text-sm font-medium text-accent-600">
                  查看专题
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}